<script setup lang="ts">
/**
 * **属性行**：只有参数，没有端口。
 *
 * 数据上的硬约束是「输入与输出不在同一行」—— 属性行连端口都没有，
 * 所以它永远不可能长出端口来。这条在 `verify:branches` 里守着。
 */
import NpRowWidget from './NpRowWidget.vue'
import type { PropertyRow } from '../../types/node'

const props = defineProps<{ row: PropertyRow; inGroup: boolean }>()

const emit = defineEmits<{
  (e: 'widget-update', widgetId: string, value: unknown): void
  (e: 'widget-resize', widgetId: string, height: number): void
}>()
</script>

<template>
  <div
    class="np-row np-row--has-widget"
    data-row-kind="property"
    :class="{ 'np-row--in-group': props.inGroup }"
  >
    <span v-if="props.row.label" class="np-row__label">{{ props.row.label }}</span>

    <NpRowWidget
      :row="props.row"
      @update="(id, value) => emit('widget-update', id, value)"
      @resize="(id, height) => emit('widget-resize', id, height)"
    >
      <template #widget-custom="slotProps">
        <slot name="widget-custom" v-bind="slotProps" />
      </template>
    </NpRowWidget>
  </div>
</template>
